/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Budget_HelpInputs */

const en_ai_budget_help = /** @type {(inputs: Ai_Budget_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imports pause at the limit and you get a note.`)
};

const de_ai_budget_help = /** @type {(inputs: Ai_Budget_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Limit pausieren Importe und du bekommst eine Nachricht.`)
};

/**
* | output |
* | --- |
* | "Imports pause at the limit and you get a note." |
*
* @param {Ai_Budget_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_budget_help = /** @type {((inputs?: Ai_Budget_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Budget_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_budget_help(inputs)
	return en_ai_budget_help(inputs)
});